import { STORE_MODULE_NAME } from "./contentTypeStoreModule";

export default function useContentType() {

  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {
    fetchDataUrl,
  }
}
